export default __webpack_public_path__ + "static/media/coffe1.502c6ea0.jpg";